import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import axiosInstance from '../axiosInstance';
import { FaSearch, FaPlus } from "react-icons/fa";
import { API_URL_All } from "../api";
import "react-toastify/dist/ReactToastify.css";
import "../css/Products.css";
import { toast } from "react-toastify";
import * as general from '../libs/general';
import Paging from '../components/Paging';
import AdLayout from '../components/AdLayout';
import DataTable from '../components/ui/DataTable';
import ProductEditor from '../components/products/ProductEditor';
import { fetchProductsDivisionPermissions } from "../libs/customerCreatePermission";

const Products = () => {
  const [productEditorData, setProductEditorData] = useState(null);
  const [pageData, setPageData] = useState({ content: [] });
  const [message, setMessage] = useState("");
  const hasRun = useRef(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [productsDivisionPerm, setProductsDivisionPerm] = useState({
    loaded: false,
    personal: { view: false, create: false, edit: false, delete: false },
    shared: { view: false, create: false, edit: false, delete: false },
    exportExcel: false,
  });
  const [productAccess, setProductAccess] = useState("allowed");
  const navigate = useNavigate();

  const [selectedItems, setSelectedItems] = useState([]);
  /** productId -> mở/đóng danh sách product properties (cha–con) */
  const [expandedProductIds, setExpandedProductIds] = useState({});


  useEffect(() => {
    searchProducts();
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const bundle = await fetchProductsDivisionPermissions(axiosInstance);
      if (cancelled) return;
      setProductsDivisionPerm({ loaded: true, ...bundle });
      const canEnter =
        bundle.personal.view ||
        bundle.personal.edit ||
        bundle.shared.view ||
        bundle.shared.edit;
      if (!canEnter) {
        setProductAccess("denied");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const handleChangeItemsPerPage = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    searchProducts({ page: 0, size: newItemsPerPage });
  };

  const handlePageChange = (page) => {
    searchProducts({ page: page - 1 });
  };
  const handleSearchChange = (e) => {
    var searchValue = e.target.value;
    searchProducts({ page: 0, keyword: searchValue });
    setSearchQuery(e.target.value);
  };

  const searchProducts = async (filter) => {
    var checkAllTag = document.querySelector('.check_all');
    if (checkAllTag) {
      checkAllTag.removeAttribute('data-unchecked');
      checkAllTag.checked = false;
    }

    if (window.calling) return;
    window.calling = true;
    setIsLoading(true);
    setMessage('');
    var params = general.getSession('search_products');

    var formData = general.getFormData('.form_filter');
    Object.assign(params, formData);

    if (!hasRun.current) {
      hasRun.current = true;
      var oldParams = general.getSession('search_products');
      Object.assign(params, oldParams);
    }

    if (filter) Object.assign(params, filter);
    general.setSession('search_products', params);
    window.initializeFilterValue(params);

    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));

    var response = {};
    try {
      response = await axiosInstance.get('/api/products/searchProducts', { params: filteredParams });
      setPageData(response.data);
      bindSelectAllCheckbox(response);
    } catch (error) {
      if (error.status === 401) setTimeout(navigate, 2000, '/dang-nhap');
      setPageData({ content: [] });
      setMessage(error.message);
      console.error(error);
    }
    window.calling = false;
    setIsLoading(false);
  };
  const openProductEditor = (id, rowItem) => {
    const isShare = rowItem?.productType === "share";
    const pm = isShare ? productsDivisionPerm.shared : productsDivisionPerm.personal;
    if (id === 0 && !productsDivisionPerm.personal.create) return;
    if (id > 0 && !(pm.view || pm.edit)) return;
    setProductEditorData({
      id: id,
      canView: pm.view,
      canCreate: id === 0 ? productsDivisionPerm.personal.create : pm.create,
      canEdit: pm.edit,
      canDelete: pm.delete,
    });
  };
  const openShareProductEditor = (id, rowItem) => {
    const pm = productsDivisionPerm.shared;
    if (id === 0 && !pm.create) return;
    if (id > 0 && !(pm.view || pm.edit)) return;
    var obj = {
      id: id,
      canView: pm.view,
      canCreate: id === 0 ? pm.create : pm.create,
      canEdit: pm.edit,
      canDelete: pm.delete,
    };
    if (id === 0) {
      obj.productType = 'share';
      obj.id = id;
      //obj.providerId = model.id;
      //obj.providerName = model.name;
    }
    setProductEditorData(obj);
  };

  function bindSelectAllCheckbox(response) { 
    var checkAllTag = document.querySelector('.check_all');

    if (checkAllTag) {
      checkAllTag.removeAttribute('data-unchecked');
      checkAllTag.checked = false;


      var listIds = [];
      checkAllTag.removeAttribute('data-listIds');
      if (response.data.listIds) {
        listIds = response.data.listIds;
        checkAllTag.setAttribute('data-listIds', response.data.listIds.join(","));
      }
      var uncheckedList = checkAllTag.getAttribute('data-unchecked');
      if (uncheckedList || checkAllTag.checked) {
        if (!uncheckedList) uncheckedList = '';
        var uncheckedItems = uncheckedList.split(',').map(item => parseInt(item.trim())).filter(Number.isInteger);
        var selectedIds = listIds.filter(item => !uncheckedItems.includes(item));
        setSelectedItems(selectedIds);
      }
    }
  }

  function removeItem(array, value) {
    return array.filter(item => item !== value);
  }
  const handleSelectItem = (id) => {
    setSelectedItems((prevSelected) => {
      const updated = prevSelected.includes(id)
        ? prevSelected.filter((orderId) => orderId !== id)
        : [...prevSelected, id];

      var totalNumberPages = pageData.page.totalPages;
      var checkallTag = document.querySelector('.check_all');
      if (totalNumberPages === 1 && pageData.listIds) {
        const allChecked = pageData.listIds.every(orderId => updated.includes(orderId));
        if (checkallTag) checkallTag.checked = allChecked;
      }
      var isChecked = updated.includes(id);
      var uncheckedList = checkallTag.getAttribute('data-unchecked');
      var idText = id + '';
      if (totalNumberPages > 1 && (checkallTag.checked || uncheckedList)) {
        if (!uncheckedList) uncheckedList = '';
        var uncheckedItems = uncheckedList.split(',').filter(str => str !== "");
        if (isChecked) {
          uncheckedItems = removeItem(uncheckedItems, idText);
        } else {
          var isExisted = uncheckedItems.includes(idText);
          if (!isExisted) uncheckedItems.push(idText);
        }
        var textUncheckedItems = uncheckedItems.join(',');

        if (textUncheckedItems) {
          checkallTag.setAttribute('data-unchecked', textUncheckedItems);
          checkallTag.checked = false;
        } else {

          checkallTag.removeAttribute('data-unchecked');
          checkallTag.checked = true;
        }
      }

      return updated;
    }
    );
  };
  const handleSelectAll = () => {
    var checkAllTag = document.querySelector('.check_all');
    checkAllTag.removeAttribute('data-unchecked');
    var isChecked = checkAllTag.checked;
    if (!isChecked) {
      // Nếu tất cả đơn hàng đã được chọn, bỏ chọn tất cả
      setSelectedItems([]);
    } else {
      // Nếu chưa chọn hết, chọn tất cả đơn hàng
      setSelectedItems(pageData.listIds);
    }
  };

  const handleExportFile = async (obj) => {
    if (productsDivisionPerm.loaded && !productsDivisionPerm.exportExcel) {
      toast.error("Bạn không có quyền xuất file Excel.");
      return;
    }
    var listIds = selectedItems;
    if (listIds.length === 0) {
      toast.error("Phải chọn ít nhất 1 mục");
      return;
    }
    const textIds = listIds.join(';');
    var requestApi = `${API_URL_All}/api/products/exportproducts?codes=${textIds}`;

    //setIsLoading2(true);
    general.downloadFile(requestApi, "Ho_so_SP.xlsx");
    //setIsLoading2(false);
  };

  /** Danh sách product properties từ API (ProductDto.properties) */
  const getProductProperties = (item) => {
    const list = item?.properties;
    if (!Array.isArray(list) || list.length === 0) return [];
    return list;
  };

  const toggleProductProperties = (productId) => {
    setExpandedProductIds((prev) => ({ ...prev, [productId]: !prev[productId] }));
  };

  const canInteractProductRow = (item) => {
    if (!productsDivisionPerm.loaded) return false;
    if (item?.productType === "share") {
      return productsDivisionPerm.shared.view || productsDivisionPerm.shared.edit;
    }
    return productsDivisionPerm.personal.view || productsDivisionPerm.personal.edit;
  };

  return (
    <div>
      <AdLayout>
        {productAccess === "denied" ? (
          <div className="container py-4">
            <div className="alert alert-warning mb-0">Truy cập không được phép.</div>
          </div>
        ) : (
        <>
        <div className="table-responsive web-table customer-management-page">
          <div className="container-fluid">
            <div className="row bg-dark align-items-center">
              <div className="col-12 col-md-7 order-3 order-md-1 py-1 d-flex align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <button
                    className="btn btn-success btn-sm me-1"
                    type="button"
                    aria-expanded="false"
                    disabled={!productsDivisionPerm.loaded || !productsDivisionPerm.exportExcel}
                    title={
                      productsDivisionPerm.loaded && !productsDivisionPerm.exportExcel
                        ? "Không có quyền xuất Excel"
                        : undefined
                    }
                    onClick={handleExportFile}
                  >
                    Xuất file excel
                  </button>
                  {productsDivisionPerm.loaded &&
                    (productsDivisionPerm.personal.create || productsDivisionPerm.shared.create) && (
                    <div className="dropdown">
                      <button className="btn btn-success btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <FaPlus /> Thêm mới
                      </button>
                      <ul className="dropdown-menu">
                        {productsDivisionPerm.personal.create && (
                          <li onClick={() => openProductEditor(0)}>
                            <span className="dropdown-item" role="button">Sản phẩm cá nhân</span>
                          </li>
                        )}
                        {productsDivisionPerm.shared.create && (
                          <li onClick={() => openShareProductEditor(0)}>
                            <span className="dropdown-item" role="button">Sản phẩm dùng chung</span>
                          </li>
                        )}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-7 col-md-2 py-1 fw-bold text-white text-uppercase d-flex align-items-center justify-content-star order-1 order-md-2">
                Danh sách sản phẩm
              </div>
              <div className="col-5 col-md-3 py-1 order-2 order-md-3 d-flex justify-content-end align-items-center">
                <form id="form_filter" className="form_filter mb-0 w-auto">
                  <div className="input-group search-block flex-nowrap">
                    <input name="keyword"
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Tìm kiếm..."
                      value={searchQuery}
                      onChange={(e) => handleSearchChange(e)}  // Ensure `e` is passed to the function
                    />
                    <button className="btn btn-light btn-sm" type="button" title="Tìm kiếm..." onClick={(event) => searchProducts({ page: 0 })}>
                      <FaSearch />
                    </button>
                  </div>
                </form>
              </div>
            </div>


          </div>

          <section className="pt-1">
            <DataTable maxHeight="calc(100vh - 160px)" className="table-normal" data-loading={isLoading}>
              <table className="table table-striped table-bordered border-normal products-admin-table">
                <thead className="table-primary">
                  <tr>
                    <th className='sticky text-center' width="21px">
                      <input type="checkbox" title='Check all' className='check_all' onChange={() => handleSelectAll()} />
                    </th>
                    <th width="30px" className="sticky left-20 text-center">STT</th>
                    <th width="150px" className="text-center"><span>Mã sản phẩm</span></th>
                    <th className="text-center"><span>Tên sản phẩm</span></th>
                    <th className="text-center"><span>Hình ảnh</span></th>
                    <th className="text-center"><span>Giá nhập</span></th>
                    <th className="text-center"><span>Giá khai báo</span></th>
                    <th className="text-center"><span>Mã HS</span></th>
                    <th className="text-center"><span>Thuế nhập (%)</span></th>
                    <th className="text-center"><span>Thuế vat (%)</span></th>
                    <th className="text-center"><span>Ghi chú</span></th>
                    <th className="text-center">
                      <span>Danh mục</span>
                      <span className="filter-ib" data-form="form_filter" data-filter="categories" data-source-url={API_URL_All + '/api/products/searchTreeCategoryNames'} data-min="190px"><i className="filter-i"></i></span>
                    </th>
                    <th width="150px" className="text-center">
                      <span>Mã khách hàng</span>
                      <span className="filter-ib" data-form="form_filter" data-filter="customers" data-source-url={API_URL_All + '/api/users/searchUserCodes'} data-min="100px"><i className="filter-i"></i></span>
                    </th>
                    <th width="100px" className="text-center">
                      <span>Phân loại</span>
                      <span className="filter-ib" data-form="form_filter" data-filter="types" data-source-key="list_product_types"><i className="filter-i"></i></span>
                    </th>
                    <th width="140px" className="text-center"><span>Người phụ trách</span></th>
                  </tr>
                </thead>
                <tbody>
                {pageData.page && pageData.page.content && pageData.page.content.map((item, index) => {
                  const properties = getProductProperties(item);
                  const hasProperties = properties.length > 0;
                  const isExpanded = !!expandedProductIds[item.id];
                  const rowNo = (pageData.page.number * pageData.page.size) + index + 1;

                  return (
                    <React.Fragment key={item.id}>
                      <tr className="product-row-parent">
                        <td className='sticky' title={item.id}>
                          <input
                            type="checkbox"
                            checked={selectedItems.includes(item.id)}
                            onChange={() => handleSelectItem(item.id)}
                          />
                        </td>

                        <td className="sticky left-20 text-center">
                          <div className="d-flex align-items-center justify-content-center gap-1">
                            {hasProperties && (
                              <motion.button
                                type="button"
                                className="btn-expand-variant"
                                aria-expanded={isExpanded}
                                onClick={() => toggleProductProperties(item.id)}
                                title={isExpanded ? "Thu gọn thuộc tính con" : "Mở thuộc tính con"}
                                whileTap={{ scale: 0.88 }}
                                transition={{ type: 'spring', stiffness: 420, damping: 24 }}
                              >
                                {isExpanded ? '−' : '+'}
                              </motion.button>
                            )}
                            <span>{rowNo}</span>
                          </div>
                        </td>
                        <td className="text-start" title={`ID: ${item.id}`}>
                          {canInteractProductRow(item) ? (
                            <span
                              role="button"
                              tabIndex={0}
                              style={{ color: "#485766" }}
                              onClick={() => openProductEditor(item.id, item)}
                              onKeyDown={(e) => e.key === "Enter" && openProductEditor(item.id, item)}
                            >
                              {item.code}
                            </span>
                          ) : item.code}
                        </td>
                        <td className="text-start mw-200">
                          {canInteractProductRow(item) ? (
                            <span
                              role="button"
                              tabIndex={0}
                              className="product-name-link"
                              onClick={() => openProductEditor(item.id, item)}
                              onKeyDown={(e) => e.key === "Enter" && openProductEditor(item.id, item)}
                            >
                              {item.name}
                            </span>
                          ) : item.name}
                        </td>
                        <td width="100px" className="text-start over-visible">
                          <div className="img-incol">
                            <div className="img-incol-thumb">
                              <img alt="" src={`${API_URL_All}/${item.imagePath}`} />
                            </div>
                            <img alt="" className="popup-image" src={`${API_URL_All}/${item.imagePath}`} />
                          </div>
                        </td>
                        <td className="text-center">{general.formatNumber(item.price)}</td>
                        <td className="text-center">{general.formatNumber(item.priceDeclare)}</td>
                        <td className="text-start">{item.taxCode}</td>
                        <td className="text-center">{item.taxImport}</td>
                        <td className="text-center">{item.taxVat}</td>
                        <td className="text-start mw-200">{item.note}</td>
                        <td className="text-start mw-200">
                          {item.listCategoryNames && item.listCategoryNames.map((item2, index2) => (
                            <div className="block-02" key={index2}>{item2}</div>
                          ))}
                        </td>
                        {item.productType === 'share' && (
                          <td className="text-center mw-200">
                            {item.listCustomers && item.listCustomers.map((item2, index2) => (
                              <div className="block-03" key={index2}>{item2.customerCode}</div>
                            ))}
                          </td>
                        )}
                        {item.productType !== 'share' && (
                          <td className="text-center">{item.customerCode}</td>
                        )}
                        <td className="text-start">{general.getProductTypeText(item.productType)}</td>
                        <td className="text-start">{item.careName || "—"}</td>
                      </tr>
                      {hasProperties && (
                        <AnimatePresence initial={false}>
                          {isExpanded && properties.map((prop, propIndex) => {
                            const propKey = `${item.id}-prop-${prop.id ?? propIndex}`;
                            const enterDelay = propIndex * 0.042;
                            const exitDelay = (properties.length - 1 - propIndex) * 0.032;
                            return (
                              <motion.tr
                                key={propKey}
                                className="product-property-row"
                                initial={{ opacity: 0, y: -10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{
                                  opacity: 0,
                                  y: -8,
                                  transition: {
                                    duration: 0.2,
                                    delay: exitDelay,
                                    ease: [0.4, 0, 1, 1],
                                  },
                                }}
                                transition={{
                                  duration: 0.26,
                                  delay: enterDelay,
                                  ease: [0.22, 1, 0.36, 1],
                                }}
                              >
                                <td className='sticky' title={item.id}></td>
                                <td className="sticky left-20 text-muted small"></td>
                                <td className="text-start" title={prop.id ? `Property ID: ${prop.id}` : `ID sản phẩm: ${item.id}`}>
                                  {prop.code ?? ''}
                                </td>
                                <td className="text-start mw-200 property-name-cell">
                                  {prop.propertiesValue ?? ''}
                                </td>
                                <td width="100px" className="text-start over-visible">
                                  <div className="img-incol">
                                    <div className="img-incol-thumb">
                                      <img alt="" src={`${API_URL_All}/${prop.imagePath || item.imagePath}`} />
                                    </div>
                                    <img alt="" className="popup-image" src={`${API_URL_All}/${prop.imagePath || item.imagePath}`} />
                                  </div>
                                </td>
                                <td className="text-center">{general.formatNumber(prop.price ?? item.price)}</td>
                                <td className="text-center">{general.formatNumber(prop.priceDeclare ?? item.priceDeclare)}</td>
                                <td className="text-start">{prop.taxCode ?? item.taxCode}</td>
                                <td className="text-center">{prop.taxImport ?? item.taxImport}</td>
                                <td className="text-center">{prop.taxVat ?? item.taxVat}</td>
                                <td className="text-start mw-200">
                                  {[prop.note, prop.description].filter(Boolean).join(' · ') || ''}
                                </td>
                                <td className="text-start mw-200 text-muted small">
                                  {item.listCategoryNames && item.listCategoryNames.map((item2, index2) => (
                                    <div className="block-02" key={index2}>{item2}</div>
                                  ))}
                                </td>
                                {item.productType === 'share' && (
                                  <td className="text-start mw-200 text-muted small">
                                    {item.listCustomers && item.listCustomers.map((item2, index2) => (
                                      <div className="block-03" key={index2}>{item2.customerCode}</div>
                                    ))}
                                  </td>
                                )}
                                {item.productType !== 'share' && (
                                  <td className="text-start text-muted small">{item.customerCode}</td>
                                )}
                                <td className="text-start text-muted small">{general.getProductTypeText(item.productType)}</td>
                                <td className="text-start text-muted small">{item.careName || "—"}</td>
                              </motion.tr>
                            );
                          })}
                        </AnimatePresence>
                      )}
                    </React.Fragment>
                  );
                })}
                  {message === '' && pageData.page && pageData.page.content.length === 0 && (
                    <tr>
                      <td colSpan="15" className="text-center">Không tìm thấy dữ liệu</td>
                    </tr>
                  )}
                  {message !== '' && (
                    <tr>
                      <td colSpan="15" className="text-center">{message}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </DataTable>
          </section>
          <div className="mt-2 d-flex justify-content-end align-items-center">
            <Paging
              pageData={pageData}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleChangeItemsPerPage}
            />
          </div>
        </div>

        <input type="hidden" id="list_product_types" value="Cá nhân,Dùng chung" />

        {productEditorData && (
          <ProductEditor data={productEditorData} handleSearch={searchProducts} />
        )}
        </>
        )}

      </AdLayout>
    </div>
  );
}
export default Products;